import { CALL_API } from "../middleware/api";
export const FETCH_DELIVERY_CANCEL = 'FETCH_DELIVERY_CANCEL';
export const SUCCESS_DELIVERY_CANCEL = 'SUCCESS_DELIVERY_CANCEL';
export const FAILURE_DELIVERY_CANCEL = 'FAILURE_DELIVERY_CANCEL';

export function cancel(data) {
    return {
        type: FETCH_DELIVERY_CANCEL,
        [CALL_API]: {
            endpoint: `/api/delivery/cancel?orderId=${data.orderId}`,
            method: 'post',
            types: [SUCCESS_DELIVERY_CANCEL, FAILURE_DELIVERY_CANCEL],
            data
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/delivery.js